"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var smoothscroll_polyfill_1 = __importDefault(require("smoothscroll-polyfill"));
var helpers_1 = require("./modules/helpers");
var cookie_notice_1 = require("./modules/cookie-notice");
smoothscroll_polyfill_1.default.polyfill();
var scrollToPosition = function (scrollTo) {
    if (scrollTo instanceof HTMLElement && (window && window.innerHeight)) {
        var innerHeight_1 = window.innerHeight;
        var rect = scrollTo.getBoundingClientRect();
        var scrollDistance = rect.y - (rect.height + 85);
        if (window.scrollY <= 80) {
            window.scroll({
                top: scrollDistance,
                behavior: 'smooth'
            });
        }
    }
};
window.addEventListener('scroll', function (event) {
    var navbar = document.querySelector('.primary-header');
    window.innerWidth > 767 && window.scrollY > 2
        ? navbar.setAttribute('tight', 'true')
        : navbar.setAttribute('tight', 'false');
}, { passive: true });
document.addEventListener('click', function (event) {
    var target = event.target;
    if (target.matches('.hamburger') || target.matches('.hamburger div')) {
        helpers_1.toggleAttr(document.body, 'menu-expanded', ['true', 'false']);
    }
    if (target.matches('.menu-item-has-children > a')) {
        event.preventDefault();
        var parent_1 = target.parentNode, subMenu = parent_1.querySelector('.sub-menu');
        helpers_1.animateY(subMenu, {
            duration: 300
        });
        helpers_1.toggleAttr(parent_1, 'expanded', ['true', 'false']);
    }
    // if ( document.body.getAttribute( 'menu-expanded' ) === 'true' && ! target.classList.contains( 'menu-primary-container' ) ) {
    //   document.body.setAttribute( 'menu-expanded', 'false' );
    // }
    if (target.matches('.notification .dashicons-dismiss')) {
        var notification = document.querySelector('.notification');
        notification.setAttribute('data-alert', 'false');
        window.sessionStorage.setItem('dismissed', 'true');
    }
    if (target.matches('.cookie-accept')) {
        event.preventDefault();
        if (window.localStorage) {
            localStorage.setItem('cookieAccepted', 'true');
        }
        var bar = document.querySelector('.cookie-notice');
        bar.setAttribute('data-visible', 'false');
    }
});
document.addEventListener('DOMContentLoaded', function () {
    cookie_notice_1.runCookieNotice();
    var searchParams = new URLSearchParams(window.location.search), notification = document.querySelector('.notification'), shareTriggers = document.querySelectorAll('a#share');
    // copyTriggers = document.querySelectorAll( 'a#copy') as NodeListOf<HTMLAnchorElement>;
    if (shareTriggers) {
        Array.from(shareTriggers).map(function (trigger) { return trigger.addEventListener('click', function (event) { return helpers_1.share(event); }); });
    }
    // if ( copyTriggers ) {
    //   Array.from(copyTriggers).map( trigger => trigger.addEventListener( 'click', event => copy( event ) ) );
    // }
    if (searchParams.get('date')) {
        scrollToPosition(document.querySelector('.archive-select'));
    }
    if (searchParams.get('sort')) {
        scrollToPosition(document.querySelector('.filter'));
    }
    if (notification && null == window.sessionStorage.getItem('dismissed')) {
        setTimeout(function () { return notification.setAttribute('data-alert', 'true'); }, 2000);
    }
}, { once: true });
